module.exports = __webpack_public_path__ + "static/media/dollar 1.e654c1f3.svg";